import React from "react";

const DeliveryTermsSkeletonRow = ({ rowIndex }) => {
    const rowParity = rowIndex % 2 === 0 ? "row-even" : "row-odd";

    return (
        <div className={`card quote-project-row skeleton-row ${rowParity}`}>
            <div className="card-body">
                <div className="quote-project-grid">
                    <div className="project-cell">
                        <span className="skeleton-block skeleton-avatar"></span>
                        <div className="project-copy">
                            <span className="skeleton-block skeleton-line skeleton-line-title"></span>
                            <span className="skeleton-block skeleton-line skeleton-line-sub"></span>
                        </div>
                    </div>

                    <div>
                        <span className="skeleton-block skeleton-line"></span>
                    </div>

                    <div className="mode-cell">
                        <span className="skeleton-block skeleton-line skeleton-line-short"></span>
                    </div>

                    <div>
                        <span className="skeleton-block skeleton-pill"></span>
                    </div>

                    <div className="open-cell"></div>
                </div>
            </div>
        </div>
    );
};

export default DeliveryTermsSkeletonRow;